// Timing, TTL and rate-limit values the backend and frontend share.
// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
export const LATE_ANSWER_GRACE_MS = 5000;
export const DEFAULT_TIME_LIMIT_MS = 20_000;
export const STAGE_TTL_SECONDS = 5 * 60;
// Uniform TTL for every row written under a session partition (SESSION,
// NAME#, PLAYER#, ANSWER#) and for connection rows. 24 h ≫ any
// real session; DynamoDB TTL then deletes student-entered names on its own.
export const SESSION_TTL_SECONDS = 24 * 60 * 60;
// Per-source-IP cap on POST /sessions, fixed 60 s window. Generous because
// whole schools share one NAT IP; a teacher normally creates ~1/lesson.
export const SESSION_CREATES_PER_MINUTE = 30;
//# sourceMappingURL=constants.js.map